import { Button, H2 } from "@sellar-io/components";
import { useState } from "react";
import { Alert } from "../alert/Alert";
import sellarLogo from "../../images/sellar-logo-new.png";
import { useSellarSession } from "../../hooks/useSellarSession";
import {
  getSessionInitializationFailure,
  reportSessionInitializationFailure,
} from "../../hooks/sessionInitializationFailure";

export const SessionInitializationError = () => {
  const { state, retryInitialization, sellar } = useSellarSession();
  const [signingOut, setSigningOut] = useState(false);
  const [signOutFailed, setSignOutFailed] = useState(false);
  if (
    state.status !== "initialization-error" &&
    state.status !== "retrying-initialization"
  )
    return null;
  const retrying = state.status === "retrying-initialization";

  const { failure } = state;
  const message =
    failure.kind === "authentication" || failure.stage === "authentication"
      ? "We couldn’t verify your sign-in. Please try again, or sign out and sign in again."
      : failure.stage === "user" || failure.stage === "session"
        ? "We couldn’t load your Sellar account. Please try again."
        : "We couldn’t load your business. Please try again.";

  const signOut = async () => {
    setSigningOut(true);
    setSignOutFailed(false);
    try {
      await sellar.signOut();
    } catch (cause: unknown) {
      setSignOutFailed(true);
      reportSessionInitializationFailure(
        getSessionInitializationFailure(cause, "authentication"),
      );
    }
    setSigningOut(false);
  };

  return (
    <div className="flex h-full w-full flex-col justify-center gap-4">
      <div className="flex flex-col gap-2">
        <div className="mb-4 flex justify-center">
          <img src={sellarLogo} alt="Sellar Logo" className="w-[50px]" />
        </div>
        <H2 className="text-center">Unable to finish signing in</H2>
      </div>
      <div role="alert">
        <Alert
          type="error"
          message={
            signOutFailed
              ? "We couldn’t sign you out. Please try again."
              : message
          }
          className="w-full"
        />
      </div>
      <Button
        className="w-full"
        onClick={retryInitialization}
        loading={retrying}
        disabled={signingOut || retrying}
        aria-label={retrying ? "Retrying sign-in" : "Try again"}
      >
        <span>{retrying ? "Retrying…" : "Try again"}</span>
      </Button>
      <Button
        className="w-full"
        color="secondary"
        onClick={() => void signOut()}
        loading={signingOut}
        disabled={signingOut || retrying}
      >
        <span>Sign out</span>
      </Button>
    </div>
  );
};
